import React from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import { Sparkles, User, ImagePlus, Loader2 } from 'lucide-react';
import { t } from '../../lib/i18n';
import { ArticleSuggestions } from './ArticleSuggestions';

const CoachAvatar = () => (
  <div className="flex-shrink-0 mt-1">
    <div className="w-8 h-8 rounded-lg bg-lux-gold/10 flex items-center justify-center">
      <Sparkles className="w-4 h-4 text-[var(--lux-gold)]" />
    </div>
  </div>
);

const UserAvatar = () => (
  <div className="flex-shrink-0 mt-1">
    <div className="w-8 h-8 rounded-lg bg-white/10 flex items-center justify-center">
      <User className="w-4 h-4 text-white/60" />
    </div>
  </div>
);

export const ChatMessage = ({ message }) => {
  const isUser = message.role === 'user';
  return (
    <div className={`flex gap-3 fade-in ${isUser ? 'justify-end' : 'justify-start'}`} data-testid={`chat-message-${message.role}`}>
      {!isUser && <CoachAvatar />}
      <div className={`max-w-[92%] md:max-w-[80%] px-4 py-3 ${isUser ? 'chat-bubble-user' : 'chat-bubble-coach'}`}>
        {isUser ? (
          <p className="text-sm text-white/90">
            {message.hasImage && (
              <span className="inline-flex items-center gap-1 text-[var(--lux-gold)] text-xs mb-1"><ImagePlus className="w-3 h-3" /> Photo</span>
            )}
            {message.content}
          </p>
        ) : (
          <>
            <div className="ai-response">
              <ReactMarkdown remarkPlugins={[remarkGfm]}>{message.content}</ReactMarkdown>
            </div>
            <ArticleSuggestions text={message.content} />
          </>
        )}
      </div>
      {isUser && <UserAvatar />}
    </div>
  );
};

export const ChatTypingIndicator = ({ language, analyzing }) => (
  <div className="flex gap-3 fade-in" data-testid="chat-typing-indicator">
    <CoachAvatar />
    <div className="chat-bubble-coach px-4 py-3">
      <div className="flex items-center gap-2 text-sm text-[var(--lux-amber)]">
        <Loader2 className="w-4 h-4 animate-spin" />
        {t(analyzing ? 'analyzing' : 'thinking', language)}
      </div>
    </div>
  </div>
);
